import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getAthleteGenders } from '@api/lookups';
import { IAthleteGender } from '@interfaces/lookups';

export const handleGetAthleteGenders = createAsyncThunk<AxiosResponse<IAthleteGender[]>, void>(
  'getAthleteGenders',
  getAthleteGenders,
);
